module.exports = __webpack_public_path__ + "img/65709.b8bc780b.png";